<template>
  <div class="security-dialog">
    <el-dialog :title="state === 1 ? '新增' : '修改'"
               v-ops:width="680"
               :visible.sync="formShow"
               v-dialogDrag
               @close="formClose"
               class=""
               :close-on-click-modal="false">
      <ioc-form :option="formOption"
                v-model="accountForm"
                ref="form">
        <template slot="chargePerson">
          <div>
            <el-input v-model="accountForm.chargePerson"
                      @focus="openChoose"
                      placeholder="请选择人员"
                      class="person-choose"></el-input>
          </div>
        </template>
        <!-- 2021.4.28日 需求增加此字段 -->
        <template slot="appointmentCarNotifyFlag">
          <div>
            <el-radio-group v-model="accountForm.appointmentCarNotifyFlag">
              <el-radio label="0">不接收</el-radio>
              <el-radio label="1">接收</el-radio>
            </el-radio-group>
          </div>
        </template>
        <!-- 2021.4.28日 需求增加此字段 -->
        <template slot="appointmentNoCarNotifyFlag">
          <div>
            <el-radio-group v-model="accountForm.appointmentNoCarNotifyFlag">
              <el-radio label="0">不接收</el-radio>
              <el-radio label="1">接收</el-radio>
            </el-radio-group>
          </div>
        </template>
        <template slot="region">
          <div>
            <region-tree :isPageTree="true"
                         :isSerch="false"
                         :checkedArr="checkedArr"
                         @checkedKeys="checkedKeys"
                         ref="regiontree" />
          </div>
        </template>
      </ioc-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="saveWorkGroup"
                   v-status>
          保存
        </el-button>
        <el-button @click="formClose"> 取消 </el-button>
      </span>
    </el-dialog>
    <!-- 人员选择弹框 -->
    <el-dialog title="人员选择"
               :visible.sync="linkDialog"
               v-dialogDrag
               width="760px"
               class="choose-container">
      <ioc-table ref="personTable"
                 :data="accountData"
                 :option="accountOption"
                 :page="accountPage"
                 @size-change="personChangeSize"
                 @current-change="currentChange"
                 @search-change="searchList"
                 @search-reset="personReset">
        <template slot="id"
                  slot-scope="scope">
          <el-radio :label="scope.row.accountNumber"
                    v-model="accountId"
                    @change="radioChange(scope.row)">{{ "" }}</el-radio>
        </template>
      </ioc-table>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="confirmChoose">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 对话框组件
 */
import groupOption from "../options/group";
import accountOption from "../options/accountOptions";
import regionTree from '@src/components/business/app-area-tree'
import { api } from "../api";
import utils from "@src/common/utils";
const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, "");
};
export default {
  components: {
    regionTree
  },
  name: 'EduDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '80%'
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    state: {
      type: Number,
      default: ''
    },
    treeInfo: {
      type: Object,
      default: {}
    },
    checkedArr: {
      type: Array,
      default: () => {
        return []
      },
    }
  },
  data () {
    return {
      formShow: false,
      formOption: groupOption(),
      accountForm: {
        name: "",
        chargePerson: "",
        appointmentCarNotifyFlag: '0',
        appointmentNoCarNotifyFlag: '0',
        region: ''
      },
      linkDialog: false,
      accountData: [],
      accountPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      accountSearch: {},
      // 账户Id
      accountId: "",
      currenAccountInfo: {},
      accountOption: accountOption(),
      chooseAreaCode: [],
    }
  },
  mounted () {
    this.getAccountList();
  },
  created () { },
  methods: {
    open () {
      this.formShow = true;
      // 修改的时候需要回填
      setTimeout(() => {
        if (this.state === 2) {
          // console.log('---this.treeInfo---', this.treeInfo);
          this.accountForm.name = this.treeInfo.name;
          this.accountForm.chargePerson = this.treeInfo.leaderName;
          this.accountForm.appointmentCarNotifyFlag = this.treeInfo.appointmentCarNotifyFlag;
          this.accountForm.appointmentNoCarNotifyFlag = this.treeInfo.appointmentNoCarNotifyFlag;
          this.accountId = this.treeInfo.leaderCode;
          this.$nextTick(() => {
            // this.$refs.regiontree.$refs.dialogTree.setCheckedKeys(this.treeInfo.areaDevGroupCodeList || [])
            this.$refs.regiontree.setChooseKeys(this.treeInfo.areaDevGroupCodeList)
          })
        }
      }, 300)
    },
    onOpen () {
      setTimeout(() => {
        this.$emit('open')
      }, 300)
    },
    handleCheckChange (data, isCheck) {
      let arrLabel = [];
      let arr = [];
      let res = this.$refs.regiontree.$refs.dialogTree.getCheckedNodes(true, true);
      res.forEach(item => {
        arrLabel.push(item.areaDevGroupName);
        arr.push({
          areaDevGroupName: item.areaDevGroupName,
          areaDevGroupCode: item.areaDevGroupCode
        });
        arr.push(item.areaDevGroupCode)
      });
    },
    checkedKeys (keysArr) {
      this.chooseAreaCode = keysArr;
    },
    // 新增/修改工作组
    saveWorkGroup () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url =
            this.state === 1 ? api.addSecurityWorkGroup : api.updateSecurityWorkGroup;
          let params = {};
          if (this.state === 1) {
            params = {
              areas: this.chooseAreaCode,
              parentCode: this.treeInfo.id,
              securityWorkGroupLeader: this.accountId,
              appointmentCarNotifyFlag: this.accountForm.appointmentCarNotifyFlag,
              appointmentNoCarNotifyFlag: this.accountForm.appointmentNoCarNotifyFlag,
              securityWorkGroupName: trim(this.accountForm.name)
            };
          } else {
            params = {
              areas: this.chooseAreaCode,
              securityWorkGroupCode: this.treeInfo.id,
              appointmentCarNotifyFlag: this.accountForm.appointmentCarNotifyFlag,
              appointmentNoCarNotifyFlag: this.accountForm.appointmentNoCarNotifyFlag,
              securityWorkGroupLeader: this.accountId,
              securityWorkGroupName: trim(this.accountForm.name)
            };
          }
          console.log('===工作组参数====', params);
          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message({
                message: this.state === 1 ? "新增成功" : "修改成功",
                type: "success",
                duration: 2000,
              });
              this.formClose();
              this.$emit("refresh")

            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增修改弹窗 关闭清除数据
    formClose () {
      this.formShow = false;
      this.accountForm = {
        name: "",
        chargePerson: "",
        appointmentCarNotifyFlag: '0',
        appointmentNoCarNotifyFlag: '0',
        region: ''
      }
      this.accountId = ""
      this.currenAccountInfo = {}
      this.$refs.regiontree.$refs.dialogTree.setCheckedKeys([]);
      this.$refs["form"].clearValidate();
    },
    openChoose () {
      this.linkDialog = true;
    },
    // 获取人员选择弹框中人员列表
    getAccountList () {
      const params = {};
      params.accountType = 1;
      params.nickName = this.accountSearch.nickName;
      params.accountNumber = this.accountSearch.accountNumber;
      params.pageNo = this.accountPage.pageNum;
      params.pageSize = this.accountPage.pageSize;
      this.$fetch(api.queryAccouts, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.accountData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.accountPage.total = response.returnObj
          ? response.returnObj.total
          : 0;
      });
    },
    radioChange (val) {
      if (val) {
        this.currenAccountInfo = val;
        this.accountId = this.currenAccountInfo.accountNumber;
        this.accountForm.chargePerson = val.nickName;
      }
    },
    // 人员选择确认弹框
    confirmChoose () {
      if (!this.accountId) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择账户",
        });
        return;
      }
      this.linkDialog = false;
    },
    // 员工弹框修改每页数据数量
    personChangeSize (val) {
      this.accountPage.pageNum = 1;
      this.accountPage.pageSize = val;
      this.getAccountList();
    },
    currentChange (val) {
      this.accountPage.pageNum = val;
      this.getAccountList();
    },
    searchList (param) {
      this.accountSearch = Object.assign(param);
      this.accountPage.pageNum = 1;
      this.getAccountList();
    },
    personReset () {
      this.getAccountList();
    },
  }
}
</script>
<style lang="scss">
.security-dialog {
  .person-choose {
    .el-input__inner::placeholder {
      color: #00e8bb;
      text-align: right;
    }
    /* 谷歌 */
    .el-input__inner::-webkit-input-placeholder {
      color: #00e8bb;
      text-align: right;
    }
    /* 火狐 */
    .el-input__inner:-moz-placeholder {
      color: #00e8bb;
      text-align: right;
    }
    /*ie*/
    .el-input__inner:-ms-input-placeholder {
      color: #00e8bb;
      text-align: right;
    }
  }
}
</style>
